export const AboutAppActionTypes = {
  SET_ABOUT_APP: "SET_ABOUT_APP",
  SET_CENTER: "SET_CENTER",
  SET_ZOOM: "SET_ZOOM",
}